import React from "react";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import shouldUpdate from "recompose/shouldUpdate";
import compose from "recompose/compose";
import FlatButton from "material-ui/FlatButton";
import ImageEye from "material-ui/svg-icons/image/remove-red-eye";
import {translate} from "admin-on-rest";

const linkToRecord = (basePath, id) => `${basePath}/${encodeURIComponent(id)}`;

const ShowButton = ({
  basePath = "",
  label = "aor.action.show",
  record = {},
  translate
}) => (
  <FlatButton
    primary
    label={label && translate(label)}
    icon={<ImageEye />}
    containerElement={<Link to={`${linkToRecord(basePath, record.id)}/show`} />}
    hoverColor="transparent"
    fullWidth
    style={{overflow: "inherit", textAlign: "left"}}
  />
);

ShowButton.propTypes = {
  basePath: PropTypes.string,
  label: PropTypes.string,
  record: PropTypes.object,
  translate: PropTypes.func.isRequired
};

const enhance = compose(
  shouldUpdate(
    (props, nextProps) =>
      (props.record &&
        nextProps.record &&
        props.record.id !== nextProps.record.id) ||
      props.basePath !== nextProps.basePath ||
      (props.record == null && nextProps.record != null)
  ),
  translate
);

export default enhance(ShowButton);



// WEBPACK FOOTER //
// ./src/components/CRM/ShowButton.js